import { GraficoComponent } from './../home/Components/grafico.component';
import { ContratosUser } from './../entities/ContratosUser.entity';
import { Contrato } from './../entities/contrato.entity';
import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { UserService } from '../services/user.service';
import { SessionService } from '../services/session.service';
import { UsuarioOnline } from '../entities/UsuarioOnline.entity';
import { UsuarioUpdate } from '../entities/usuarioUpdate.entity';
import { Respuesta } from '../entities/respuesta.entity';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'app-menudesktop',
  templateUrl: './menudesktop.component.html'
})
export class MenudesktopComponent implements OnInit {
  public static changeContrato: Subject<boolean> = new Subject();
  public currentUrl: string;
  public resultado: Respuesta;
  public messageCabecera: string;
  public messageComplet: string;
  public typeException: number;
  public contratos: Contrato[];
  public positionselected: number;
  public efactura: boolean;
  public explo: string;
  public factText = 'factura';
  @Output() contratoenvio = new EventEmitter();

  constructor(private userService: UserService, private sessionService: SessionService) {
    MenudesktopComponent.changeContrato.subscribe(() => {
      this.SeleccionarContrato();
    });
  }

  ngOnInit() {
    if (this.sessionService.contratos !== undefined) {
      this.explo = this.sessionService.datosExplotacion.Codigo.toUpperCase();
      if (this.explo === 'MELILLA') {
        this.factText = 'pre-factura';
      }
      this.contratos = this.sessionService.contratos;
      this.efactura = this.sessionService.efactura;
      if (this.sessionService.contratoSelected === undefined) {
        this.sessionService.contratoSelected = this.contratos[0];
        this.sessionService.PosicionContratoSelected = 0;
      } else {
        this.positionselected = this.sessionService.PosicionContratoSelected;
      }
    }
  }

  public SeleccionarContrato() {
    this.contratos = this.sessionService.contratos;
    this.efactura = this.sessionService.efactura;
    this.positionselected = this.sessionService.PosicionContratoSelected;
    this.sessionService.PosicionContratoSelected = this.positionselected;
    this.sessionService.contratoSelected = this.contratos[this.positionselected];
    this.CargaFacturasContratoSeleccionado();
  }

  public ContratoSeleccionado() {
    this.sessionService.PosicionContratoSelected = this.positionselected;
    this.sessionService.contratoSelected = this.contratos[this.positionselected];
    this.CargaFacturasContratoSeleccionado();
  }

  public CargaFacturasContratoSeleccionado() {
    const contratoUsuario = new ContratosUser();
    let usuario = new UsuarioOnline();
    usuario = this.sessionService.usuario;
    contratoUsuario.ContratoSeleccionado = this.sessionService.contratoSelected.Codigo;
    if (this.sessionService.contratoSelected.Facturas.length === 0) {
      this.userService.getContratos(contratoUsuario.ContratoSeleccionado).subscribe(
        response => this.authenticateOnSuccess(response),
        error => this.authenticateOnError(error)
      );
    } else {
      GraficoComponent.UpdateData.next(this.sessionService.contratoSelected.Facturas);
      this.contratoenvio.emit({ contratoSeleccionado: this.sessionService.contratoSelected });
    }
  }

  private authenticateOnSuccess(response: any) {
    this.sessionService.contratoSelected.Facturas = response[0].Facturas;
    this.sessionService.contratos[this.positionselected].Facturas = response[0].Facturas;
    GraficoComponent.UpdateData.next(this.sessionService.contratoSelected.Facturas);
    this.contratoenvio.emit({ contratoSeleccionado: this.sessionService.contratoSelected });
  }

  private authenticateOnError(error) { }

  public subscribirFacturaElectronica() {
    const user: UsuarioUpdate = new UsuarioUpdate();
    let usuarioOnline: UsuarioOnline = new UsuarioOnline();
    usuarioOnline = this.sessionService.usuario;
    usuarioOnline.EFactura = true;
    user.UsuarioOnline = usuarioOnline;
    this.userService.updateuser(this.sessionService.explotacion, user).subscribe(
      response => this.updateuserOnSuccess(response),
      response => this.updateuserOnError(response)
    );
  }

  public updateuserOnSuccess(response) {
    this.efactura = true;
    this.sessionService.efactura = true;
    // this.messageCabecera = 'Usuario dato de alta en la factura electronica';
    // this.messageComplet = 'El usuario se ha subscrito correctamente para recibir la factura electronica';
    // this.typeException = 2;
  }

  public updateuserOnError(response) {
    // let respuesta: Respuesta = response;
    // this.messageCabecera = 'Actualización de usuario finalizado con errores';
    // this.messageComplet = respuesta.Ex.Message;
    // this.typeException = respuesta.TipoExcepcion;
  }

}



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/shared/menudesktop.component.ts